<sm-title-bar [pageTitle]="pageTitle" [back]="true"> </sm-title-bar>


<div class="" *ngIf="!loader && memberDueInvoiceList.length > 0">
  <div>
    <div class="plan-card" style="position: relative;" *ngFor="let data  of memberDueInvoiceList" (click)="openInvoice(data)">
      <!-- <button mat-icon-button [matMenuTriggerFor]="menu2" class="more-button" aria-label="More options"
        style="position: absolute; right: 15px; top: 10px;">
        <mat-icon>more_vert</mat-icon>
      </button> -->
      <mat-menu #menu2="matMenu">
        <button mat-menu-item (click)="openInvoice(data)">
          <mat-icon class="material-icons-outlined">receipt_long</mat-icon>
          <span>{{ 'customer_due_bookings.op2' | translate }}</span>
        </button>
      </mat-menu>
      <div class="d-flex " style="align-items: center;">
        <h2 class="plan-title"> {{data.inv_no}}</h2>
      </div>
      <p class="plan-info">
        <span class="label">Amount: </span> <span class="value">{{data.currency_symbol}}{{data.total_price.toFixed(2)}}</span>,
        <span class="label">Due: </span> <span class="value">{{data.currency_symbol}}{{data.payment_due.toFixed(2)}}</span>
      </p>
      <p class="plan-cost">
        <span class="value">{{data.creation_time | date}}, {{data.creation_time | date: 'shortTime' : 'UTC'}}</span>
      </p>

      <div class="arrow_due" >
            <mat-icon>arrow_forward</mat-icon>
          </div>
    </div>
  </div>
</div>

<div class="row" *ngIf="!loader && memberDueInvoiceList.length == 0">
  <div class="col-sm-12" >
    <div style="padding: 20px 18px 20px 18px;border-radius: var(--dra-radius-x-small);transition: 0.3s;">
      <div class="top_section_order">
        <div class="row">
         <div class="nal_rrty">
          <div style="text-align:center;min-height: 500px;padding-top: 210px">
          <div class="cv_notifia">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M192 464h-64a8 8 0 0 0 0 16h64a8 8 0 0 0 0-16z" fill="#878787" opacity="1" data-original="#000000" class=""></path><path d="M468 160H304V36a28.031 28.031 0 0 0-28-28H44a28.031 28.031 0 0 0-28 28v440a28.031 28.031 0 0 0 28 28h232a28.031 28.031 0 0 0 28-28V360h164a28.031 28.031 0 0 0 28-28V188a28.031 28.031 0 0 0-28-28zM197.75 24l-4 16h-67.5l-4-16zM288 476a12.01 12.01 0 0 1-12 12H44a12.01 12.01 0 0 1-12-12V36a12.01 12.01 0 0 1 12-12h61.75l6.49 25.94A8 8 0 0 0 120 56h80a8 8 0 0 0 7.76-6.06L214.25 24H276a12.01 12.01 0 0 1 12 12zm16-196h24v32h-24zm176 52a12.01 12.01 0 0 1-12 12H304v-16h32a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-32v-24h176zm0-108H304v-16h176zm0-32H304v-16h164a12.01 12.01 0 0 1 12 12z" fill="#878787" opacity="1" data-original="#000000" class=""></path><path d="M456 264h-72a8 8 0 0 0 0 16h72a8 8 0 0 0 0-16zM456 288h-72a8 8 0 0 0 0 16h72a8 8 0 0 0 0-16zM456 312h-32a8 8 0 0 0 0 16h32a8 8 0 0 0 0-16zM160 160a96 96 0 1 0 96 96 96.108 96.108 0 0 0-96-96zm0 176a80 80 0 1 1 80-80 80.091 80.091 0 0 1-80 80z" fill="#878787" opacity="1" data-original="#000000" class=""></path><path d="m202.343 226.343-51.094 51.094L124.8 257.6a8 8 0 1 0-9.6 12.8l32 24a8 8 0 0 0 10.457-.743l56-56a8 8 0 0 0-11.314-11.314z" fill="#878787" opacity="1" data-original="#000000" class=""></path></g></svg>
          </div>
          <div>
            <p style="margin-top: 18px; color: #a8a8a8; font-size: 17px;  line-height: 24px;">
              There's no due payment to show here. Either all the payments are cleared or no invoice raised so far.
           </p>
         </div>
          </div>
        </div>
       </div>
      </div>
    </div>
  </div>
</div>

<!-- <mat-card appearance="outlined">
  <mat-card-header class="justify-content-between align-items-center mb-3">

  </mat-card-header>
  <div class="rounded-3 bg-light">
    <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="memberDueInvoiceList" [showMenuButton]="true"
      [menuDropdownTemplate]="menuTemplate" [showPagination]="true" [itemsPerPage]="25">
    </sm-data-table>
  </div>
</mat-card> -->



<!-- <ng-template #menuTemplate let-rowvalue> -->

<!-- <button mat-menu-item (click)="viewDetails(rowvalue)">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>{{ 'customer_due_bookings.op1' | translate }}</span>
    </button> -->
<!-- <button mat-menu-item (click)="openInvoice(rowvalue)">
    <mat-icon class="material-icons-outlined">receipt_long</mat-icon>
    <span>{{ 'customer_due_bookings.op2' | translate }}</span>
  </button>
</ng-template> -->
<!-- <mat-paginator
  *ngIf="!loader"
    class="mt-4"
    [length]="datalength"
    [pageSize]="25"
    (page)="onPageChange($event)"
  >
  </mat-paginator> -->